
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/question/[questionId]",
      function () {
        return require("private-next-pages/question/[questionId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/question/[questionId]"])
      });
    }
  